export default "__VITE_ASSET__D41sfdTD__"